"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _inputUtils = _interopRequireDefault(require("../lib/inputUtils"));

require("./input.css");

var Input = function Input(props) {
  return new _inputUtils["default"]().renderInputComponent(props);
};

Input.propTypes = {
  name: _propTypes["default"].string,
  type: _propTypes["default"].string,
  isInvalid: _propTypes["default"].bool,
  disableInputFeedback: _propTypes["default"].bool,
  innerRef: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func, _propTypes["default"].string]),
  options: _propTypes["default"].array,
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  inline: _propTypes["default"].bool,
  validationProps: _propTypes["default"].any
};
Input.defaultProps = {
  type: "text",
  disableInputFeedback: false
};
Input.displayName = "OrionInput";
var _default = Input;
exports["default"] = _default;